export default __webpack_public_path__ + "static/media/decentral-txt.b2381d37.png";